
export interface ErrorHandler {
    onError(error: Response|Error): any;
}

export function withErrorHandler(request: Promise<Response>, handler: ErrorHandler) {
    // Note: We do not catch the error, because otherwise the promise chain would continue
    return request.then(r => checkResponseStatus(r, handler), e => handler.onError(e));
}

function checkResponseStatus(response: Response, handler: ErrorHandler) {
    if (!response.ok) {
        handler.onError(response);
        return Promise.reject('Server returned an error'); 
    }
    return response;
}